import { getSystemType, isMiniProgramOrWebview } from '@nibfe/mkt-env-api';
import { SystemType } from '@nibfe/mkt-env-api/src/libs/enum';
export function getUTM() {
    try {
        const systemType = getSystemType();
        let utm_medium = systemType === SystemType.android ? 'android' : systemType === SystemType.harmony ? 'HarmonyOS' : systemType === SystemType.ios ? 'iphone' : isMiniProgramOrWebview() ? 'WEIXINPROGRAM' : '';
        return utm_medium;
    }
    catch (e) {
        return 'iphone';
    }
}
